import styled, { CSSProperties } from 'styled-components';
import colors from '../../style/colors';

// components
import { SpacingProps } from '../box';
import { withSpacing } from '../../utils/with-spacing';

interface ScrollableContainerProps extends SpacingProps {
  height?: number | string;
  maxHeight?: number | string;
  overflowX?: 'auto' | 'scroll' | 'hidden';
  overflow?: 'auto' | 'scroll' | 'hidden';
  flexGrow?: CSSProperties['flexGrow'];
}

const ScrollableContainer = styled.div.withConfig({
  shouldForwardProp: prop => !['height', 'maxHeight', 'overflowX', 'overflow', 'flexGrow'].includes(prop),
})<ScrollableContainerProps>`
  ${withSpacing};
  height: ${props => (typeof props.height === 'number' ? `${props.height}px` : props.height || 'auto')};
  max-height: ${props => (typeof props.maxHeight === 'number' ? `${props.maxHeight}px` : props.maxHeight || 'none')};
  overflow-y: auto;
  ${props => props.overflow && `overflow: ${props.overflow}`};
  ${props => props.overflowX && `overflow-x: ${props.overflowX}`};
  ${props => props.flexGrow && `flex-grow: ${props.flexGrow}`};
  &:focus-visible {
    border: 2px solid ${colors.sky};
  }
`;

export default ScrollableContainer;
